import React from 'react';
export const StarFillIcon = props => (/*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-color)",
  d: "M22.43 9.505c-.1-.29-.28-.55-.52-.74-.25-.19-.54-.3-.85-.32l-5.57-.39-2.06-5.2c-.12-.29-.31-.53-.57-.71-.25-.17-.55-.27-.86-.27a1.537 1.537 0 0 0-1.42.98l-2.1 5.23-5.54.36c-.3.02-.6.13-.84.32-.25.19-.43.45-.52.74-.1.3-.11.63-.02.93s.26.57.5.77l4.26 3.6-1.27 4.98c-.08.34-.07.69.05 1.02s.33.61.61.82c.27.19.6.3.93.31.34.01.67-.08.95-.26l4.4-2.78h.02l4.73 2.99c.25.16.53.24.82.24.24 0 .47-.05.68-.16s.4-.26.54-.45.24-.4.29-.64c.04-.23.03-.47-.03-.7l-1.34-5.44 4.24-3.53a1.592 1.592 0 0 0 .49-1.7z"
})));